module.exports = __webpack_public_path__ + "static/media/neutral_event_response.c1f1a167.png";